<template>
  <div class="container" v-if="isOpen">
    <index-header :common="common" :marketInfo="common.marketInfo"></index-header>
    <index-nav
      :list="home.indexNavList"
      :iconStyle="home.iconStyle"
      :imgs="home.bannerList"
      :common="common"
    ></index-nav>
    <index-tips :couponArr="couponArr" :isShowcoupon="isShowcoupon"></index-tips>
    <div v-for="(item,i) in home.dataList" :key="i">
      <index-activity
        v-if="home.activityList.length && item.type=='activity' && item.isShow==1"
        :list="home.activityList"
        :items="item"
      ></index-activity>
      <index-emptyshop
        v-if="home.emptyShopList.length && item.type=='store' && item.isShow==1"
        :list="home.emptyShopList"
        :items="item"
      ></index-emptyshop>
      <index-companyList
        v-if="home.companyWallList.length && item.type=='mall' && item.isShow ==1"
        :list="home.companyWallList"
        :items="item"
      ></index-companyList>
      <index-shoplist
        v-if="home.shopsList.length && item.type=='shop' && item.isShow == 1"
        :list="home.shopsList"
        :items="item"
      ></index-shoplist>
    </div>
    <!-- 优惠券 -->
    <mt-popup
      v-model="isShowAdvertisement"
      position="center"
      pop-transition="popup-fade"
      :closeOnClickModal="clickfalse"
    >
      <advertisementMask
        :mbMaskingAds="mbMaskingAds"
        @getCoupon="getCoupon"
        @closeCoupon="closeCoupon"
      ></advertisementMask>
    </mt-popup>
    <section style="height:1rem;"></section>
    <nav-bar :tab="0"></nav-bar>
  </div>
</template>
<script>
import util from "../../utils/util";
import IndexHeader from "./components/index-header";
import IndexNav from "./components/index-nav";
import IndexTips from "./components/index-tips";
import IndexActivity from "./components/index-activity";
import IndexEmptyshop from "./components/index-emptyShop";
import IndexShoplist from "./components/index-shopList";
import IndexCompanyList from "./components/index-companyList";
import NavBar from "../../components/navbar";
import advertisementMask from "../../components/advertisementMask"
import { mapState, mapActions } from "vuex";
import storage from '../../utils/storage';
import { getIndexStyleByMarketId, indexInfo, getMbBondActiveList, addMbBond, getMaskingAds, getUserMarketInfo } from "../../utils/api";
import wx from 'weixin-js-sdk';
//import wx from 'jweixin-1.6.0'

export default {
  name: "Home",
  components: {
    NavBar,
    IndexHeader,
    IndexNav,
    IndexTips,
    IndexActivity,
    IndexEmptyshop,
    IndexCompanyList,
    IndexShoplist,
    advertisementMask
  },
  data() {
    return {
      marketId: '',
      couponArr: [],
      isShowcoupon: false,
      isShowAdvertisement: false,
      clickfalse: false,
      mbMaskingAds: {},
      isOpen:true,
    };
  },
  computed: {
    ...mapState({
      common: state => state.common,
      home: state => state.home
    })
  },
  created() {
    let that = this;
    this.marketId = this.common.marketInfo.id;
    if (!this.$route.meta.title) {
      this.getIndexStyleByMarketId();
    }
    if (!this.home.bannerList.length) {
      this.indexInfo(); // 轮播图
    }
    this.getMbBondActiveList();
    // 业主公司进来,开启定位
    if (this.common.cityId && !storage.get("historyMess" + this.common.cityId)) {
      setTimeout(() => {
        wx.ready(() => {
          wx.getLocation({
            type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
            success: function (res) {
              console.log(res)
              let marketList = [];
              for (var i in that.common.marketList) {
                marketList = marketList.concat(that.common.marketList[i].cityMarkets)
              }
              console.log(marketList)
              let distance = util.distance(res.latitude, res.longitude, marketList[0].latitude || 0, marketList[0].longitude || 0)
              console.log(distance)
              let minDistanceMarket = [];
              marketList.forEach(item => {
                if (distance > util.distance(res.latitude, res.longitude, item.latitude || 0, item.longitude || 0)) {
                  distance = util.distance(res.latitude, res.longitude, item.latitude || 0, item.longitude || 0)
                  minDistanceMarket = item;
                }
              })
              console.log(minDistanceMarket)
              storage.set("historyMess" + that.common.cityId, JSON.stringify([minDistanceMarket]));
              that.marketId = minDistanceMarket.marketId;
              that.getUserMarketInfo(minDistanceMarket.marketId)//设置项目用户数据
              that.indexInfo(); // 轮播图
              that.getIndexStyleByMarketId();
              that.getMbBondActiveList();
            },
            fail: function (res) {
              console.log(res)
            }
          });
        })
      }, 1000);
    }
  },
  activated() {
    if (this.marketId != this.common.marketInfo.id) {
      this.marketId = this.common.marketInfo.id
      this.indexInfo(); // 轮播图
      this.getIndexStyleByMarketId();
      this.getMbBondActiveList();
      this.getUserMarketInfo(this.marketId)//设置项目用户数据
    }
    this.getMaskingAds();
  },
  methods: {
    ...mapActions([
      "getBanerList",
      "getIndexStyle",
      "getActivityList",
      "getEmptyShopList",
      "getNoticeList",
      "getCompanyWallList",
      "getShopsList",
      "getMarketInfo",
      "getTheme",
      "getHolidayStyle",
      "getUserInfo",
      "getTenantInfo",
      "getTenantInfoList"
    ]),
    convert_format(data) {
      let temp = {}, tree = {};
      for (var i in data) {
        temp[data[i].name] = data[i];
      }
      for (let j in temp) {
        if (temp[j].parent_ind && temp[j].parent_ind === j) {
          if (!temp[temp[j].parent_ind].parent_ind) {
            temp[temp[j].parent_ind] = new Object()
          }
          temp[temp[j].parent_ind] = temp[j]
        } else {
          tree[j] = new Object()
        }
      }
      return tree
    },
    clearStorage() {
      localStorage.clear();
    },
    getMbBondActiveList() {
      this.isShowcoupon = false;
      var param = {
        mutations: 1,
        pageSize: 10,
        marketId: this.marketId,
        type: ''
      }
      getMbBondActiveList(param).then(res => {
        this.isShowcoupon = true;
        if (res.res && res.res.code === 10000) {
          this.loaded = true;
          var list = res.body.mbBondActiveList;
          this.couponArr = list;
        } else {
          this.couponArr = [];
        }
      });
    },
    // 首页配置tab
    getIndexStyleByMarketId() {
      getIndexStyleByMarketId({
        marketId: this.$route.query.marketId || this.marketId
      }).then(res => {
        console.log(res);
        if (res.res && res.res.code === 10000 && res.body) {
          console.log('h111111')
          if(res.body.isOpen ==0){
            var marketList =  this.common.marketList
            console.log('h22222222')
            if(!this.$route.query.cityId){
              console.log('in home open ')
              util.showModal('提示', '贵司账号已过期，请联系项目管理员。',false,"知道了", () => {
                // this.$router.push({
                //   path: "/"
                // });
              })
            }
            this.isOpen =false
            return 
          }

          console.log('h3333333')
          let data = res.body;
          // 判断是否有投诉建议模块
          data.menusList.forEach((item, index) => {
            if (item.id == 11) {
              this.$store.commit('HASTSMODULE', true);
              data.menusList.splice(index, 1)
            }
          })
          console.log('marketInfo  === ' +  this.common.marketInfo)
          // 判断是否是同创的项目,去除投诉建议模块
          // if (this.common.marketInfo.cityId == 5 || this.common.marketInfo.cityId == 2) {
          //   data.indexCenter.forEach(item => {
          //     item.tbWapServerButtonList.forEach((cur, index) => {
          //       if (cur.serverNo == 11) {
          //         item.tbWapServerButtonList.splice(index, 1)
          //       }
          //     })
          //   })
          // }
          this.getIndexStyle(data);
          document.title = res.body.indexTitle
          this.$route.meta.title = res.body.indexTitle
        }
      });
    },
    indexInfo() {
      let params = {
        marketId: this.marketId,
        userId: this.common.userId
      };
      let that = this;
      indexInfo(params).then(res => {
        console.log(res);
        if (res.body && res.res && res.res.code === 10000) {
          let bannerList = res.body.bannerList || [];
          this.getBanerList(bannerList); //轮播图
          let noticeList = res.body.noticeList || [];
          this.getNoticeList(noticeList); //公告
          let data = res.body.activeList || []; //活动数据
          data.forEach(item => {
            if (item.actLabel) {
              item.actLabel = item.actLabel.split(";");
            }
          });
          this.getActivityList(data);
          let shopData = res.body.vacantShopList; //空铺数据
          shopData.forEach(item => {
            if (item.label) {
              item.label = item.label.split(",");
            }
          });
          shopData.sort(util.compare("sortOrder"));
          this.getEmptyShopList(shopData);
          let companyWallList = res.body.companyWallList || [];
          this.getCompanyWallList(companyWallList)//企业墙
          let shopsList = res.body.shopsList || [];
          shopsList.forEach(item => {
            if (item.tagNames) {
              item.tagNames = item.tagNames.split(/[\n\s+,，；;]/g);
            }
            if (item.discount) {
              item.discount = item.discount.split(/[\n\s+,，；;]/g);
            }
          });
          this.getShopsList(shopsList)//商业生活
          // 首页分享
          let address = window.location.href.split('?')[0];
          var link = address;
          if(that.common.marketInfo.id && that.common.cityId){
             link = link + '?marketId=' + that.common.marketInfo.id + '&cityId=' + that.common.cityId
          }else if(that.common.marketInfo.id && !that.common.cityId){
             link = link + '?marketId=' + that.common.marketInfo.id
          }else if(!that.common.marketInfo.id && that.common.cityId){
             link = link + '?cityId=' + that.common.cityId
          }
          console.log("分享link ====" +link)
          wx.ready(() => {
            let obj = {
              title: that.common.marketInfo.marketName, // 分享标题
              desc: that.$route.meta.title,
              link :link,
             // link: address + '?marketId=' + that.common.marketInfo.id + '&cityId=' + that.common.cityId, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: bannerList[0] ? bannerList[0].banImg : '',// 分享图标
              success: function () {
                util.showToast('已分享')
              }
            }
            wx.onMenuShareAppMessage(obj)
            wx.onMenuShareTimeline(obj)
          })
        }
      });
    },
    getCoupon() {
      addMbBond({
        memberCode: this.common.userInfo.memberCode,
        activeId: this.mbMaskingAds.bondActiveId,
        marketId: this.common.marketInfo.id,
        templateId: this.mbMaskingAds.templateId,
        beginTime: this.mbMaskingAds.beginTime.split('.').join(''),
        endTime: this.mbMaskingAds.endTime.split('.').join('')
      }).then(res => {
        // console.log(res);
        if (res.res.code === 10000) {
          util.showToast('领取成功，请至我的优惠券查看');
        } else {
          util.showToast(res.res.msg);
        }
        this.isShowAdvertisement = false;
      }
      );
    },
    closeCoupon() {
      this.isShowAdvertisement = false;
    },
    getMaskingAds() {
      if (!this.common.userId) {
        return;
      }
      getMaskingAds({
        memberCode: this.common.userInfo.memberCode,
        marketId: this.common.marketInfo.id,
        // actType: '2', // 2商业
        displayPosition: '0' // 显示在首页 ；1:显示在我的页面
      }).then(res => {
        if (res && res.res.code === 10000 && res.body.mbMaskingAds) {
          if (res.body.mbMaskingAds && res.body.mbMaskingAds != null) {
            this.mbMaskingAds = res.body.mbMaskingAds
          } else {
            this.mbMaskingAds = '';
          }
          // displayCondition 0:首次进入显示，1:每次进入显示
          //  storage.removeS('displayConditionArray');
          if (res.body.mbMaskingAds.perm) {
            let displayCondition = storage.getS('displayConditionArray');
            let arr = [];
            if (displayCondition) {
              arr = JSON.parse(displayCondition)
            }
            var hasSave = false;
            for (var i = 0; i < arr.length; i++) {
              if (arr[i] == res.body.mbMaskingAds.id) {
                hasSave = true;
                break;
              }
            }

            if (
              res.body.mbMaskingAds.displayCondition == 0 &&
              hasSave
            ) {
              this.isShowAdvertisement = false;
            } else {
              if (!this.mbMaskingAds) {
                this.isShowAdvertisement = false;
              } else {
                //  storage.removeS('displayConditionArray');
                this.isShowAdvertisement = true;
              }

              if (res.body.mbMaskingAds.displayCondition == 0) {
                let displayCondition = storage.getS('displayConditionArray');
                let arr = [];
                if (displayCondition) {
                  arr = JSON.parse(displayCondition)
                }
                arr.push(res.body.mbMaskingAds.id)
                storage.setS(
                  'displayConditionArray', JSON.stringify(arr));
              }
            }
          }
          if (res.body.mbMaskingAds.discountMode === 2) {
            res.body.mbMaskingAds.amountDiscount = (
              res.body.mbMaskingAds.amountDiscount / 10
            ).toFixed(1);
          }
          // this.mbMaskingAds = res.body.mbMaskingAds;
        }
      });
    },
    getUserMarketInfo(marketId) {
      getUserMarketInfo({}, { marketId: marketId }).then(res => {
        console.log(res)
        if (res.res && res.res.code === 10000 && res.body) {
          if (res.body.tbMarketInfo) {
            this.getMarketInfo(res.body.tbMarketInfo);
            this.getTheme(res.body.tbMarketInfo.styleType);//设置全局主题色
            this.getHolidayStyle(res.body.tbMarketInfo.holidayStyle);//设置全局主题色
          }
          if (res.body.userInfo) {
            this.getUserInfo(res.body.userInfo);
          } else {
            this.getUserInfo({});
          }
          if (res.body.userTenantInfo) {
            this.getTenantInfo(res.body.userTenantInfo);
          } else {
            this.getTenantInfo({});
          }
          if (res.body.userTenantInfoList && res.body.userTenantInfoList.length) {
            this.getTenantInfoList(res.body.userTenantInfoList);
          } else {
            this.getTenantInfoList([])
          }
        }
      })
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.container {
  min-height: 100vh;
}
</style>
